import styled, {keyframes} from 'styled-components';
import {DimensionProps} from '../customTypes';
import {getRelativeWidth} from "../../../config";

interface PositionAdjustableComponentProps {
    offsetTop: number;
    offsetLeft: number;
}

interface IconProps extends DimensionProps {
    delay: number;
}

const fadeInAnimation = () => keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

const fadeOutAnimation = () => keyframes`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;

const iconAnimation = () => keyframes`
  0% {
    transform: scale(.5);
    opacity: 0;
  }

  90% {
    transform: scale(1.1);
    opacity: 1;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const SmallRingAnimation = keyframes`
    0% { opacity: 0; }
    20%, 75% { opacity: 1; }
    100% { opacity: 0; }
`;

const BigRingAnimation = keyframes`
    0%, 20% { opacity: 0; }
    40%, 80% { opacity: 1; }
    100% { opacity: 0;}
`;

const PositionAdjustableComponent = styled.div <PositionAdjustableComponentProps>`
    top: ${(PositionAdjustableComponentProps) => PositionAdjustableComponentProps.offsetTop + '%'};
    left: ${(PositionAdjustableComponentProps) => PositionAdjustableComponentProps.offsetLeft + '%'};
`;

export const LandingpageClickableContainer = styled(PositionAdjustableComponent)`
    display: flex;
    flex-direction: column;
    align-items:center;
    width: 15%;
    position: absolute;
    cursor: pointer;
`;

export const TooltipContainer = styled.div`
    margin-top: 1rem;
    opacity: 0;
    animation: ${fadeInAnimation} 0.5s ease-in-out 1.5s forwards;
`;

export const LandingpageClickableIcon = styled.div<IconProps>`
    width: ${IconProps => IconProps.width}%;
    opacity: 0;
    animation: ${iconAnimation} .5s ease-in-out ${IconProps => IconProps.delay}s forwards;

    object {
        width: 100%;
    }
    svg {
        height: 100%;
    }
`;

export const TooltipText = styled.p`
    white-space:pre-line;
    text-align: center;
    margin:0;
    padding: 1rem;
    padding-top: 0.7rem;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    background: rgb(255, 255, 255);
    background: linear-gradient(180deg, rgba(255, 255, 255, 1) 90%, rgba(255, 255, 255, 0) 100%);
    color: #666;
    line-height: 1.1rem;
    letter-spacing: -0.25px;
    font-weight: 500;
    position: relative;

    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 0;
        height: 0;
        border-bottom: 10px solid #fff;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        transform: translateY(-75%);
    }
`;

export const ConnectionWrapper = styled.div<DimensionProps>`
    width: ${DimensionProps => DimensionProps.width}vW;
    position: absolute;
    top: 9.4%;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    animation: ${fadeInAnimation} 1s ease-in-out 2s forwards, ${fadeOutAnimation} 1s ease-in-out 5s forwards;

    &:before {
        content: '';
        width: ${getRelativeWidth(2)}vW;
        height: 100vH;
        background: #fff;
        display: block;
        position: absolute;
        left: 50%;
        transform: translateY(-100%);
    }
`;

export const LandingpageButtonContainer = styled.div`
    position: absolute;
    display: flex;
    bottom: 0;
    right: 2%;
`;

const arrowAnimation = () => keyframes`
    to {stroke-dashoffset: 0}
`;

const LandingPageArrowContainer = styled.div`
    position: absolute;
    width: 41.5%;
    & svg {
        height: 100%;
    }
    & path, #right-arrow-animation {
        stroke-dasharray: 1600;
        stroke-dashoffset: 1600;
        animation: ${arrowAnimation} 1s linear 0.8s forwards;
    }
`;

export const LandingpageUpperArrowContainer = styled(LandingPageArrowContainer)`
    left: 20.5%;
    transform: scaleY(1.2);
    top: 38.5%;
`;
export const LandingpageLowerArrowContainer = styled(LandingPageArrowContainer)`
    left: 20.5%;
    top: 56%;
`;
export const LandingpageRightArrowContainer = styled(LandingPageArrowContainer)`
    top: 51%;
    left: 64%;
    width: unset;
    & #right-arrow-animation {
        animation-delay: 1.4s;
    }
    & #arrowhead {
        opacity: 0;
        animation: ${fadeInAnimation} 0.3s linear 1.5s forwards;
    }
    @media (max-width: 1700px) {
        width: 10%;
    }
`;
export const LandingpageImageContainer = styled(PositionAdjustableComponent)<IconProps>`
    position: absolute;
    width: ${(IconProps) => IconProps.width}%;
    opacity: 0;
    animation: ${fadeInAnimation} 1s ease-in-out ${(IconProps) => IconProps.delay}s forwards;
`;
export const StyledRing = styled.div`
    position: absolute;
    opacity: 0;
    animation-duration: 5s;
    animation-iteration-count: infinite;
    animation-delay: 3s;
`;
export const SmallRing = styled(StyledRing)`
    width: 100%;
    top: -3%;
    animation-name: ${SmallRingAnimation};
`;
export const BigRing = styled(StyledRing)`
    width: 120%;
    top: -11%;
    left: -10%;
    animation-name: ${BigRingAnimation};
`;
